import { faLanguage } from "@fortawesome/pro-regular-svg-icons";

import { FunctionComponent } from "react";

import { Tooltip } from "@/components/Tooltip/Tooltip";
import { Icon } from "@/components";
import { ListPerson } from "@/pages/Private/pages/List/schema/list";

export const PersonLanguage: FunctionComponent<{
	row: ListPerson;
}> = ({ row }) => {
	return (
		<div className="flex flex-row items-center gap-1.5 min-w-0 w-full overflow-hidden">
			<Tooltip className="min-w-0 overflow-hidden" content={row.prospect?.language}>
				<div className="flex flex-row items-center  gap-1 text-sm text-left min-w-0 overflow-hidden">
					{row.prospect?.language ? (
						<>
							<Icon className="text-gray-500 w-3.5 h-3.5 shrink-0" icon={faLanguage} />
							<span className="truncate text-status-info">{row.prospect?.language}</span>
						</>
					) : (
						""
					)}
				</div>
			</Tooltip>
		</div>
	);
};
